import { HiOutlineMail } from 'react-icons/hi'
import { FaWhatsapp } from 'react-icons/fa'
import { AiOutlineInstagram } from 'react-icons/ai'
import { TbBrandTelegram } from "react-icons/tb";

const data = [
    { id: 1, icon: <AiOutlineInstagram />, link: 'https://instagram.com/aglimar_edu' },
    { id: 2, icon: <HiOutlineMail />, link: 'mailto:glimarcarolinazuaje@gmail.com' },
    { id: 3, icon: <FaWhatsapp />, link: 'https://wa.me/+584265447014' },
    { id: 4, icon: < TbBrandTelegram />, link: 'https://t.me/gcarolin' }
]

export default data